import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../talukas/create/css/talukaCreate.css';
import { berAPI } from '../../../utils/api';

function BidderFormModal({ open, onClose, initial = {}, onSave }) {
  const [form, setForm] = useState({ publisherName: '', score: '', berId: '' });
  const [berList, setBerList] = useState([]);

  useEffect(() => { berAPI.getAll().then(r => setBerList(r.data.content || r.data)); }, []);

  useEffect(() => {
    if (initial) {
      setForm({
        publisherName: initial.publisherName || '',
        score: initial.score || '',
        berId: initial.berReport?.id || initial.berId || '',
      });
    }
  }, [initial]);

  const change = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const submit = e => {
    e.preventDefault();
    const payload = { publisherName: form.publisherName, score: form.score ? Number(form.score) : null, berId: form.berId ? Number(form.berId) : null };
    onSave(payload);
  };

  if (!open) return null;

  return (
    <div className="eduss-global-modal-overlay" onClick={onClose}>
      <div className="eduss-global-modal eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
        <div className="eduss-global-modal-header">
          <h3>{initial?.id ? 'Edit Bidder' : 'Add Bidder'}</h3>
          <button onClick={onClose}>×</button>
        </div>
        <form onSubmit={submit} className="eduss-taluka-create-form" style={{ padding: '16px 8px' }}>
          <div className="eduss-taluka-create-field">
            <label>publisher Name *</label>
            <input name="publisherName" value={form.publisherName} onChange={change} required />
          </div>
          <div className="eduss-taluka-create-field">
            <label>Score</label>
            <input name="score" value={form.score} onChange={change} type="number" step="0.01" />
          </div>
          <div className="eduss-taluka-create-field">
            <label>BER *</label>
            <select name="berId" value={form.berId} onChange={change} required>
              <option value="">Select BER</option>
              {berList.map(b => (<option key={b.id} value={b.id}>{b.id} ({b.tender?.refNo || b.tenderId})</option>))}
            </select>
          </div>
          <div className="eduss-student-create-actions" style={{ marginTop: 24 }}>
            <button type="button" className="eduss-student-create-btn cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="eduss-student-create-btn submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}

BidderFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  initial: PropTypes.object,
  onSave: PropTypes.func,
};

export default BidderFormModal;
